import React from "react";
import { ApolloProvider } from "@apollo/client";
import { authed } from "@utils/apoloClient";
import { Outlet } from "react-router-dom";

function AuthedLayout() {
  return (
    <ApolloProvider client={authed}>
     <Outlet /> 
    </ApolloProvider>
  );
}

export default AuthedLayout;
